export default __webpack_public_path__ + "static/media/historytime.48911178.svg";